import React, { Component } from 'react';
import { connect } from 'react-redux';
import { defaultMemoize } from 'reselect';
import Http from '../../../libs/Http';
import { getBalanceSellingAccountsMap } from './Data.selector';
import DataView from './Data.view';
import { generateAccount } from './LinkedAccountModal/LinkedAccount.util';
import { getRankedAccountsWithRank } from '../WorkArea.selectors';

export class DataContainer extends Component {

  constructor(props) {
    super(props);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.hardRemoveItem = this.hardRemoveItem.bind(this);
    this.updateSellBalance = this.updateSellBalance.bind(this);
    this.removeAmazonBalance = this.removeAmazonBalance.bind(this);
    this.toggleSection = this.toggleSection.bind(this);
    this.toggleBrowserConfig = this.toggleBrowserConfig.bind(this);
    this.toggleShowDeleted = this.toggleShowDeleted.bind(this);
    this.openAddFromCSV = this.openAddFromCSV.bind(this);
    this.addFromCSV = this.addFromCSV.bind(this);
    this.onCSVSelected = this.onCSVSelected.bind(this);
    this.editLinkedAccount = this.editLinkedAccount.bind(this);
    this.linkAccount = this.linkAccount.bind(this);
    this.toggleLinkedAccount = this.toggleLinkedAccount.bind(this);
    this.toggleLinkedAccountPrime = this.toggleLinkedAccountPrime.bind(this);
    this.closeLinkedAccountModal = this.closeLinkedAccountModal.bind(this);
    this.deleteBalanceSellingAccount = this.deleteBalanceSellingAccount.bind(this);
    this.setMaxPerDay = this.setMaxPerDay.bind(this);
    this.saveMaxPerDay = this.saveMaxPerDay.bind(this);

    this.state = {
      sections: {
        balances: true,
        activeBalances: true,
        deactivatedBalances: false,
        accounts: false,
      },
      showLinkedAccountModal: false,
      editingLinkedAccount: null,
      showBrowserConfig: false,
      browserConfig: '',
      showDeleted: false,
      showAddFromCSV: false,
      csvData: null,
      csvValidationErrors: null,
      maxPerDay: 0,
    };

    this.getAmazonBalances = defaultMemoize(this.getAmazonBalances);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_DYNAMIC_FORM_DATA',
    });
    return this.fetchMaxPerDay();
  }

  async fetchMaxPerDay() {
    const { maxPerDay } = await Http.post('/data/items', {
      body: {
        types: ['maxPerDay'],
      },
    });

    if (Array.isArray(maxPerDay)) {
      await this.saveMaxPerDay();
    } else {
      this.setState({
        maxPerDay: maxPerDay || 0,
      });
    }
  }

  async saveMaxPerDay() {
    const { dispatch } = this.props;
    await Http.post('/data/update', {
      body: {
        data: {
          maxPerDay: this.state.maxPerDay,
        },
      },
    });
    dispatch({
      type: 'FETCH_DYNAMIC_FORM_DATA',
    });
  }

  setMaxPerDay(maxPerDay) {
    this.setState({
      maxPerDay,
    });
  }

  async hasChanges() {
    const { originalAmazonAccounts, formState } = this.props;
    const { amazonAccounts } = formState.data;
    let hasChanges = false;
    if (originalAmazonAccounts.length !== amazonAccounts.length) {
      hasChanges = true;
    }

    amazonAccounts.forEach((account, i) => {
      const originalAcccount = originalAmazonAccounts[i];
      if (hasChanges) {
        return;
      }
      Object.keys(account).forEach((key) => {
        if (account[key] !== originalAcccount[key]) {
          hasChanges = true;
        }
      });
    });
    if (hasChanges) {
      alert('You have unsaved changes. This action will cause your changes to be lost. Please save your changes first.');
    }
    return hasChanges;
  }

  closeLinkedAccountModal() {
    this.setState({
      editingLinkedAccount: null,
      showLinkedAccountModal: false,
    });
  }

  async editLinkedAccount(account) {
    const hasChanges = await this.hasChanges();
    if (!hasChanges) {
      this.setState({
        editingLinkedAccount: account,
        showLinkedAccountModal: true,
      });
    }
  }

  async linkAccount(account) {
    const hasChanges = await this.hasChanges();
    if (!hasChanges) {
      this.setState({
        editingLinkedAccount: account,
        showLinkedAccountModal: true,
      });
    }
  }

  async toggleLinkedAccount(account) {
    const hasChanges = await this.hasChanges();
    if (!hasChanges) {
      const { dispatch } = this.props;
      const { isActiveLinked } = account;
      dispatch({
        type: 'TOGGLE_BALANCE_SELLING_ACCOUNT',
        payload: {
          active: !isActiveLinked,
          id: account.balanceSellingAccount.id,
        }
      });
    }
  }

  async toggleLinkedAccountPrime(account) {
    const hasChanges = await this.hasChanges();
    if (!hasChanges) {
      const { dispatch } = this.props;
      dispatch({
        type: 'TOGGLE_BALANCE_SELLING_ACCOUNT_PRIME',
        payload: {
          prime: !account.balanceSellingAccount.prime,
          id: account.balanceSellingAccount.id,
        }
      });
    }
  }

  async updateSellBalance(id) {
    const { dispatch } = this.props;
    dispatch({
      type: 'UPDATE_BALANCE_SELLING_ACCOUNT_BALANCE',
      payload: {
        id,
      }
    });
  }

  toggleShowDeleted() {
    this.setState({
      showDeleted: !this.state.showDeleted,
    });
  }

  addFromCSV() {
    const { dispatch } = this.props;
    const { csvData } = this.state;
    if (csvData) {
      dispatch({
        type: 'SAVE_CSV_DATA',
        payload: csvData,
      });
      this.setState({
        showAddFromCSV: false,
        csvData: null,
        csvValidationErrors: null,
      });
    }
  }

  deleteBalanceSellingAccount(id) {
    const { dispatch } = this.props;

    dispatch({
      type: 'DELETE_BALANCE_SELLING_ACCOUNT',
      payload: {
        id,
      }
    });
  }

  onCSVSelected(event) {
    const { formState } = this.props;
    const input = event.target;

    const reader = new FileReader();
    // TODO: add validationErrors and show them if there are issues with the uploaded data
    const validationErrors = [];
    const toBoolean = val => (val || '').toLowerCase() === 'true';

    const csvStringToArray = (strData) => {
      const objPattern = new RegExp(('(\\,|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^\\,\\r\\n]*))'), 'gi');
      let arrMatches = null;
      const arrData = [[]];
      while (arrMatches = objPattern.exec(strData)) {
        if (arrMatches[1].length && arrMatches[1] !== ',')arrData.push([]);
        arrData[arrData.length - 1].push(arrMatches[2] ?
          arrMatches[2].replace(new RegExp('""', 'g'), '"') :
          arrMatches[3]);
      }
      return arrData;
    };

    reader.onload = () => {
      const text = reader.result;
      // const rows = text.split('\n').filter(line => !!line.trim());
      const rows = csvStringToArray(text).filter(row => row.length > 1);
      const csvData = {
        amazonAccounts: [],
        balanceSellingAccounts: [],
      };
      for (let i = 1; i < rows.length; i++) {
        const row = rows[i];
        const [
          value,
          label,
          password,
          proxy,
          twoFactorCode,
          userAgent,
          deactivated,
          external,
          parseBalance,
          balanceSelling,
          first_name,
          last_name,
          address_line1,
          address_line2,
          city,
          state,
          zip_code,
          phone_number,
          max_orders_per_day,
          max_spend_per_day,
          min_order_value,
          max_order_value,
          strategy,
          prime,
          buy,
          proxy_url,
          max_orders_lifetime,
          max_spend_lifetime,
          order_gap,
          max_orders_unshipped,
          max_spend_unshipped,
          ordering_days,
        ] = row.map(item => (item || '').trim());
        let requiredFields = [
          value,
          label,
        ];
        if (toBoolean(balanceSelling)) {
          requiredFields = requiredFields.concat([
            password,
            first_name,
            address_line1,
            city,
            state,
            zip_code,
            phone_number,
          ]);
        }
        if (requiredFields.findIndex(val => !val) > -1) {
          validationErrors.push(`Required fields are missing from line ${i + 1}`);
        }
        const amazonAccount = {
          value,
          label,
          password,
          proxy,
          twoFactorCode,
          userAgent,
          strategy,
          buy,
          deactivated: toBoolean(deactivated),
          external: toBoolean(external),
          parseBalance: toBoolean(parseBalance),
          prime: toBoolean(prime),
        };
        csvData.amazonAccounts.push(amazonAccount);
        if (toBoolean(balanceSelling)) {
          csvData.balanceSellingAccounts.push(generateAccount(amazonAccount, {
            max_orders_per_day: max_orders_per_day ? parseFloat(max_orders_per_day) : undefined,
            max_orders_lifetime: max_orders_lifetime ? parseFloat(max_orders_lifetime) : undefined,
            ordering_days: ordering_days ? parseFloat(ordering_days) : undefined,
            max_spend_lifetime: max_spend_lifetime ? parseFloat(max_spend_lifetime) : undefined,
            order_gap: order_gap ? parseFloat(order_gap) : undefined,
            max_orders_unshipped: max_orders_unshipped ? parseFloat(max_orders_unshipped) : undefined,
            max_spend_unshipped: max_spend_unshipped ? parseFloat(max_spend_unshipped) : undefined,
            max_spend_per_day: max_spend_per_day ? parseFloat(max_spend_per_day) : undefined,
            min_order_value: min_order_value ? parseFloat(min_order_value) : undefined,
            max_order_value: max_order_value ? parseFloat(max_order_value) : undefined,
            proxy_url,
            billing_address: {
              first_name,
              last_name,
              address_line1,
              address_line2,
              city,
              state,
              zip_code,
              phone_number,
            },
          }));
        }
      }
      const { duplicateProxies, duplicateUsername } = this.getDuplicateAccounts(formState.data.amazonAccounts.concat(csvData.amazonAccounts));
      if (duplicateProxies.length) {
        validationErrors.push(`You are using the proxy (${duplicateProxies.map(a => a.proxy).join(', ')}) more than once`);
      }
      if (duplicateUsername.length) {
        validationErrors.push(`You are using the username (${duplicateUsername.map(a => a.value).join(', ')}) more than once`);
      }
      if (validationErrors.length) {
        this.setState({
          csvValidationErrors: validationErrors,
        });
      } else {
        this.setState({
          csvData,
          csvValidationErrors: null,
        });
      }
    };
    reader.readAsText(input.files[0]);
  }

  async openAddFromCSV(show) {
    const hasChanges = await this.hasChanges();
    if (!hasChanges) {
      this.setState({
        showAddFromCSV: show,
        csvData: null,
        csvValidationErrors: null,
      });
    }
  }

  toggleBrowserConfig({ show }) {
    const { formState } = this.props;
    const browserConfig = {
      proxies: formState.data.amazonAccounts
        .filter(account => (
          !account.isDeleted && account.proxy
        ))
        .map(account => ({
          id: (account.proxy || '').replace(/[^0-9]/ig, ''),
          name: account.label,
          proxyRules: account.proxy,
          username: '',
          password: '',
          userAgent: account.userAgent,
          settings: {
            amazonGiftcardBalanceEnabled: false, // account.parseBalance,
            amazonCredentials: {
              username: account.value,
              password: account.password
            }
          }
        })),
      workspaces: [
        {
          id: 'workspace-1',
          name: 'Default'
        }
      ]
    };
    this.setState({
      showBrowserConfig: show,
      browserConfig: JSON.stringify(browserConfig, null, 2),
    });
  }

  addItem({ key, value }) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ADD_DYNAMIC_FORM_DATA_ITEM',
      payload: {
        key,
        value,
      },
    });
  }

  removeItem({ key, id, restore }) {
    const { dispatch } = this.props;
    dispatch({
      type: 'REMOVE_DYNAMIC_FORM_DATA_ITEM',
      payload: {
        key,
        id,
        restore,
      },
    });
  }

  hardRemoveItem({ key, id }) {
    const { dispatch } = this.props;
    dispatch({
      type: 'HARD_REMOVE_DYNAMIC_FORM_DATA_ITEM',
      payload: {
        key,
        id,
      },
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_DYNAMIC_FORM_DATA_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  getDuplicateAccounts(amazonAccounts) {
    const duplicateProxies = [];
    const duplicateUsername = [];
    const proxyMap = {};
    const usernameMap = {};
    amazonAccounts.forEach((account) => {
      if (proxyMap[account.proxy]) {
        duplicateProxies.push(account);
      } else if (account.proxy && account.proxy.trim()) {
        proxyMap[account.proxy] = true;
      }
      if (usernameMap[account.value]) {
        duplicateUsername.push(account);
      } else if (account.value && account.value.trim()) {
        usernameMap[account.value] = true;
      }
    });
    return {
      duplicateProxies,
      duplicateUsername,
    };
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    const { duplicateProxies, duplicateUsername } = this.getDuplicateAccounts(formState.data.amazonAccounts);

    if (duplicateProxies.length) {
      alert(`ERROR: You are using the proxy (${duplicateProxies.map(a => a.proxy).join(', ')}) more than once`);
    } else if (duplicateUsername.length) {
      alert(`ERROR: You are using the username (${duplicateUsername.map(a => a.value).join(', ')}) more than once`);
    } else {
      dispatch({
        type: 'UPDATE_DYNAMIC_FORM_DATA',
        payload: {
          data: formState.data,
        },
      });
    }
  }

  removeAmazonBalance(_id) {
    const { dispatch } = this.props;
    dispatch({
      type: 'REMOVE_AMAZON_BALANCE',
      payload: {
        _id,
      },
    });
  }

  toggleSection(section, show) {
    this.setState({
      sections: {
        ...this.state.sections,
        [section]: show,
      },
    });
  }

  getAmazonBalances(amazonBalances) {
    return (amazonBalances || []).filter(balance => !balance.isDeleted);
  }

  render() {
    const { amazonBalances, formState } = this.props;
    return (<DataView
      {...this.props}
      {...this.state}
      amazonBalances={this.getAmazonBalances(amazonBalances)}
      removeAmazonBalance={this.removeAmazonBalance}
      deleteBalanceSellingAccount={this.deleteBalanceSellingAccount}
      updateSellBalance={this.updateSellBalance}
      toggleSection={this.toggleSection}
      toggleBrowserConfig={this.toggleBrowserConfig}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      removeItem={this.removeItem}
      hardRemoveItem={this.hardRemoveItem}
      addItem={this.addItem}
      openAddFromCSV={this.openAddFromCSV}
      addFromCSV={this.addFromCSV}
      onCSVSelected={this.onCSVSelected}
      toggleShowDeleted={this.toggleShowDeleted}
      editLinkedAccount={this.editLinkedAccount}
      linkAccount={this.linkAccount}
      toggleLinkedAccount={this.toggleLinkedAccount}
      toggleLinkedAccountPrime={this.toggleLinkedAccountPrime}
      closeLinkedAccountModal={this.closeLinkedAccountModal}
      saveMaxPerDay={this.saveMaxPerDay}
      setMaxPerDay={this.setMaxPerDay}
    />);
  }

}

function mapStateToProps(state) {
  const { data, dynamicData } = state;
  const { formState, originalAmazonAccounts } = data;
  const { amazonBalances } = dynamicData;
  return {
    originalAmazonAccounts,
    formState,
    amazonBalances,
    rankedAccounts: getRankedAccountsWithRank(state),
    balanceSellingAccountsMap: getBalanceSellingAccountsMap(state),
  };
}

export default connect(mapStateToProps)(DataContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/Data.container.js